import storage from 'redux-persist/lib/storage/session';
import { persistReducer } from 'redux-persist';

export default reducers => {
  const persistedReducer = persistReducer(
    {
      key: 'speedy',
      storage,
      whitelist: ['auth', 'config'],
    },
    reducers
  );
  return persistedReducer;
};
